<template>
  <div class="pos-cart">
    <div class="product-table">
      <transition-group name="fade-fast" mode="out-in">
        <div
          v-for="i in orderProducts"
          :key="i._id"
          class="row elevated-1 cart-item pointer"
          :class="{ 'pulse-background': i.isLoading, 'has-flight': hasFlight(i) }"
          @click="() => $emit('select-product', i)"
        >
          <div class="cell-header">
            <b>{{ i.name }} | {{ getItemBrandName(i) }}</b>
          </div>

          <div class="cell flex">
            <div style="flex: 1">
              <span :class="{ discounted: isDiscounted(i) }">
                {{
                  new Intl.NumberFormat("en-US", {
                    style: "currency",
                    currency: "USD",
                  }).format(
                    Utilities.getProductPrice(i, order.type)
                  )
                }}
              </span>
              <span class="text-color-1">x</span>
              {{ i.quantity }}
            </div>
            <div>
              <span class="text-color-1 text-thin">Sub Total </span>
              <span :class="{ discounted: isDiscounted(i) }">{{
                Utilities.formatPrice(Utilities.getProductPrice(i, order.type, i.quantity))
              }}</span>
            </div>
          </div>

          <div class="cell flex" v-if="isDiscounted(i)">
            <div style="flex: 1">
              <div class="value-discounted">
                {{
                  new Intl.NumberFormat("en-US", {
                    style: "currency",
                    currency: "USD",
                  }).format(i.salePrice)
                }}
              </div>
            </div>
            <div class="value-discounted">
              {{
                new Intl.NumberFormat("en-US", {
                  style: "currency",
                  currency: "USD",
                }).format(i.salePrice * i.quantity)
              }}
            </div>
          </div>

          <div v-show="i.name === 'dummy'">
            <br />
          </div>

          <div class="cell text-size-1">
            <span class="text-color-1">
              <span v-show="hasFlight(i)">
                <i class="fas fa-box"></i>
              {{ getFlightName(i) }} |
              </span>
              {{ i.externalFields.group.name }} |
              {{ i.externalFields.supplier.name }}
              {{ renderBatches(i) }}
            </span>
          </div>

          <span
            v-show="i.name === 'dummy'"
            class="cell text-size-1 pulse-text"
          ></span>

          <div class="discount-tag">
            <span class="text-color-1 text-thin"></span>
            {{ renderDiscounts(i) }}
          </div>

          <div v-if="i.discount > 0" class="discount-tag">
            <span class="text-size-1">Discount</span>
            {{
              new Intl.NumberFormat("en-US", {
                style: "currency",
                currency: "USD",
              }).format(i.discount)
            }}

          </div>
        </div>
      </transition-group>
    </div>
  </div>
</template>

<script>
import Utilities from "@/lib/Utilities";

export default {
  name: "PosCart",
  components: {},
  props: {
    order: {
      type: Object,
      default: () => {
        return undefined;
      },
    },
  },
  data() {
    return { Utilities };
  },
    computed: {
    orderProducts() {
      if (!this.order?.products) return [];

      return [...this.order.products].sort((a, b) => {
        const aHasFlight = a?.items?.some(item => item?.externalFields?.flight?._id != undefined);
        const bHasFlight = b?.items?.some(item => item?.externalFields?.flight?._id != undefined);

        // Sort products with flight first (true values come before false)
        if (aHasFlight && !bHasFlight) return -1;
        if (!aHasFlight && bHasFlight) return 1;

        // If both have the same flight status, maintain original order
        return 0;
      });
    },
  },
  methods: {
    getItemBrandName(item){
      return item.externalFields?.brand?.name ?? item.externalFields?.supplier?.name ?? item.brandname ?? ''
    },
    isDiscounted(product) {
      return product.unitCostOriginal > product.salePrice;
    },
    hasFlight(product){
      return product.items.some(i => i.externalFields?.flight?._id);
    },
    getFlightName(product){
      return product.items.find(i => i.externalFields?.flight?._id)?.externalFields?.flight?.name ?? 'FLIGHT';
    },
    renderBatches(product) {
      if (!product.items || product.items.length === 0) {
        return "";
      }

      let text = "";

      const batches = product.items.filter(i => !i.externalBatchId || i.externalBatchId != i.batchId)
      const labels = product.items.filter(i => i.externalBatchId)

      if (batches.length > 0) {
        text += ` | Batch #: ${batches.map(b => `${b.batchId} (${b.quantity})`).join(", ")}`;
      }

      if (labels.length > 0) {
        text += ` | Label: ${labels.map(l => `${l.externalBatchId} (${l.quantity})`).join(", ")}`;
      }

      return text;
    },
    renderDiscounts(product) {
      let text = "";

      if (!product.items || product.items.length === 0) {
        return "";
      }
      product.items.forEach((b, i) => {
        if (b.discount > 0){
        text = `Discount: ${Utilities.formatPrice(b.discount)}`;
        }
      });

      return text;
    },
    calculateProductQuantity(product) {
      if (!product.items || product.items.length == 0) {
        return 0;
      }
      try {
        return product.items.reduce((a, b) => ({
          quantity: a.quantity + b.quantity,
        })).quantity;
      } catch (error) {
        return 0;
      }
    },
  },
};
</script>

<style scoped lang="scss">
@import "./_posCart.scss";
.has-flight {
  background-color: rgba($light-accent-color, 0.1) !important;

  &:hover {
    background-color: rgba($light-accent-color, 0.2) !important;
  }
}

.light .has-flight {
  background-color: rgba($dark-accent-color, 0.1) !important;

  &:hover {
    background-color: rgba($dark-accent-color, 0.2) !important;
  }
}
</style>
